function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  "data-name": "Icon awesome-check-double",
  d: "M8.956 3.102l-.7-.7a.424.424 0 00-.6 0L3.404 6.645 1.431 4.668a.424.424 0 00-.6 0l-.7.7a.426.426 0 000 .6l2.973 2.987a.424.424 0 00.6 0l5.25-5.253a.428.428 0 00.002-.6zM3.204 4.98a.281.281 0 00.4 0l3.69-3.692a.285.285 0 000-.4l-.8-.8a.281.281 0 00-.4 0L3.404 2.77l-.982-.984a.281.281 0 00-.4 0l-.8.8a.285.285 0 000 .4z",
  fill: "#002f4d"
});
var SvgDoubleCheck = function SvgDoubleCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9.079,
    height: 9.08
  }, props), _ref);
};
export default SvgDoubleCheck;